
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import App from './App.tsx'
import './index.css'

// Initialize Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  integrations: [],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample rate for all sessions (10%)
  replaysOnErrorSampleRate: 1.0, // Sample rate for sessions with errors (100%)
  environment: import.meta.env.MODE || 'development',
  // Add initialScope for user tracking
  initialScope: {
    tags: { 
      app_version: import.meta.env.VITE_APP_VERSION || '1.0.0' // Get version from env or use default
    }
  },
});

// Wrap the app with Sentry error boundary
const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: (props) => (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center max-w-md p-6 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h2>
        <p className="text-gray-600 mb-4">
          We're sorry, but there was an error loading this page. Our team has been notified.
        </p>
        <button 
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
        >
          Refresh Page
        </button>
      </div>
    </div>
  ),
});

createRoot(document.getElementById("root")!).render(<SentryApp />);
